// Copyright Jake Tyler of Smileflex 2026
(function(){
  function log(){ try{ console.log.apply(console, arguments);}catch(e){} }

  var guardContext = window.PDM_GUARD_CONTEXT || '';

  // JSON
  var jsonEl = document.getElementById('pdm-designs-json');
  if (!jsonEl) { log('[PDM] ERROR: #pdm-designs-json not found'); return; }

  var designs = [];
  try { designs = JSON.parse((jsonEl.textContent || '').trim()); }
  catch (e) { log('[PDM] ERROR parsing JSON:', e); return; }
  if (!Array.isArray(designs) || !designs.length) { log('[PDM] No designs'); return; }

  // ----- shared namespace -----
  window.PDM = window.PDM || {};
  var PDM = window.PDM;
  PDM.designs = designs;

  // === [INSERT A: multi-colour families] =========================
(function normaliseColourFamilies(){
  function toSlug(s){ return String(s||'').trim().toLowerCase(); }
  function coerceFamilies(val){
    if (Array.isArray(val)) return val.map(toSlug).filter(Boolean);
    if (typeof val === 'string') {
      // accept "reds-oranges, blues" or "reds-oranges blues"
      return val.split(/[,\s]+/).map(toSlug).filter(Boolean);
    }
    return [];
  }
  designs.forEach(function(d){
    var fams = coerceFamilies(d.colour_family);
    // canonical array
    d._cf = fams;
    // attribute token list for DOM (space-separated)
    d._cfAttr = fams.join(' ');
  });
})();

// Tiny helpers for later filters
PDM.hasColourFamily = function(d, key){
  if (!d || !Array.isArray(d._cf)) return false;
  return d._cf.indexOf(String(key||'').toLowerCase()) >= 0;
};


// --- Tiny toast helper (one-time) ---
PDM.ensureToastHost = function(){
  if (document.getElementById('pdm-toast')) return;
  var style = document.createElement('style');
  style.textContent = `
  #pdm-toast{
    position:fixed;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%) scale(.96);
    max-width:90vw;
    background:rgba(0,0,0,.9);
    color:#fff;
    padding:12px 18px;
    border-radius:12px;
    font-size:15px;
    line-height:1.4;
    text-align:center;
    box-shadow:0 6px 25px rgba(0,0,0,.3);
    opacity:0;
    pointer-events:none;
    transition:opacity .25s ease, transform .25s ease;
    z-index:2147483647;
  }
  #pdm-toast.is-show{
    opacity:1;
    transform:translate(-50%, -50%) scale(1);
  }
`;
  document.head.appendChild(style);

  var d = document.createElement('div');
  d.id = 'pdm-toast';
  d.setAttribute('role','status');
  d.setAttribute('aria-live','polite');
  d.setAttribute('aria-atomic','true');
  document.body.appendChild(d);
};

PDM.toast = (function(){
  var tId = null;
  var DEFAULT_DURATION = 1800; // ms

  return function(msg, duration){
    try {
      PDM.ensureToastHost();
      var el = document.getElementById('pdm-toast'); 
      if (!el) return;

      var ms = (typeof duration === 'number' && duration > 0)
        ? duration
        : DEFAULT_DURATION;

      el.textContent = msg || '';
      el.classList.add('is-show');

      if (tId) clearTimeout(tId);
      tId = setTimeout(function(){
        el.classList.remove('is-show');
      }, ms);
    } catch(e){}
  };
})();









document.addEventListener('submit', function (ev) {
  var form = ev.target;
  if (!form || !document.getElementById('pdm-design-modal')) return;

  var isJunior = String(guardContext) === 'junior';
  if (!isJunior) return;

  var btn = form.querySelector('#pdm-modal-add-to-cart');
  var ageSel = form.querySelector('#pdm-age-select');

  var isAriaDisabled = btn && (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-disabled'));
  var isMissingAge   = !ageSel || !ageSel.value;

  if (isAriaDisabled || isMissingAge) {
    ev.stopImmediatePropagation();
    ev.stopPropagation();
    ev.preventDefault();

    if (ageSel) {
      ageSel.focus({ preventScroll:false });
      try { ageSel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch(_){}
      ageSel.style.borderColor = '#ff3b30';
      ageSel.style.boxShadow   = '0 0 0 2px rgba(255,59,48,.15)';
    }
    if (window.PDM && typeof PDM.toast === 'function') {
      PDM.toast("Please select your child's age range before adding to cart", 2700);
    } else {
      alert("Please select your child's age range before adding to cart", 2700);
    }
  }
}, true); // <<< capture phase





  // --- Stripe design detection & defaults (v1.1.1) ---
PDM.isStripeDesign = function(d){
  return d
    && String(d.main_category || '').toLowerCase() === 'stripes'
    && String(d.sub_category  || '').toLowerCase() === 'custom';
};

// Normalise flags/defaults for any stripe-capable designs in your JSON
(function ensureStripeFlags(){
  designs.forEach(function(d){
    if (!PDM.isStripeDesign(d)) return;

    if (typeof d.supports_stripes === 'undefined') d.supports_stripes = true;

    if (typeof d.default_style === 'undefined'){
      // Slug with '3' => default to 3 stripes, else 2
      d.default_style = /3/.test(String(d.slug || '')) ? 3 : 2;
    }

    if (!Array.isArray(d.default_colours) || !d.default_colours.length){
      // First-open defaults you specified
      d.default_colours = (d.default_style === 3)
        ? ['blue','white','black']   // 3-stripes
        : ['blue','black'];          // 2-stripes (uses 1 & 3)
    }

    if (typeof d.default_middle === 'undefined'){
      // Remember this when switching 2 -> 3; last chosen will override at runtime
      d.default_middle = 'white';
    }
  });
})();

// Helper to read defaults by slug (used later by the modal/configurator)
PDM.getStripeDefaults = function(slug){
  var d = PDM.getDesignBySlug ? PDM.getDesignBySlug(slug) : null;
  if (!PDM.isStripeDesign(d)) return null;
  return {
    style: d.default_style,
    colours: Array.isArray(d.default_colours) ? d.default_colours.slice(0) : [],
    middle: d.default_middle
  };
};

// Lightweight event emitter for cross-block signalling
PDM.emit = function(name, detail){
  try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch(e){}
};

  PDM.saved   = PDM.saved || new Map(); // slug -> design
  PDM.getDesignBySlug = function(slug){
    var s = String(slug || '').toLowerCase();
    return designs.find(function(d){ return String(d.slug||'').toLowerCase() === s; }) || null;
  };
  PDM.isSaved = function(slug){ return PDM.saved.has(String(slug||'').toLowerCase()); };
  // toggles and returns new state (true if saved after toggle)

    // --- GLOBAL persistence (shared across elite/pro/performance/junior) ---
  var GLOBAL_STORAGE_KEY = 'pdm_saved_slugs_v1';

  // Unified order for "My Saved" (mixes slugs + custom-stripes variants)
// Each entry: { t:'slug'|'variant', k:'<slug>'|'<saved_id>' }
var ORDER_STORAGE_KEY = 'pdm_saved_order_v1';

// Recently Viewed (mixes slugs + custom-stripes variants)
// Each entry: { t:'slug'|'variant', k:'<slug>'|'<saved_id>' }
var RECENT_STORAGE_KEY = 'pdm_recently_viewed_v1';

PDM.recentStorage = {
  load: function(){
    try {
      var raw = localStorage.getItem(RECENT_STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr)
        ? arr.filter(function(x){ return x && (x.t==='slug' || x.t==='variant') && x.k; })
        : [];
    } catch(e){ return []; }
  },
  save: function(list){
    try { localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(Array.isArray(list) ? list : [])); }
    catch(e){}
  },
  addToFront: function(type, key){
    var t = String(type || '');
    var k = String(key || '').toLowerCase();
    if (!k || (t !== 'slug' && t !== 'variant')) return;

    var list = PDM.recentStorage.load();

    // de-dupe by t+k
    list = list.filter(function(x){
      return !(x && x.t === t && String(x.k || '').toLowerCase() === k);
    });

    list.unshift({ t: t, k: k });

    // cap at 10
    if (list.length > 10) list = list.slice(0, 10);

    PDM.recentStorage.save(list);
        // If Recently Viewed block exists on page, refresh it immediately
    if (window.PDM && PDM.renderRecentlyViewed) {
      try { PDM.renderRecentlyViewed(); } catch(e) {}
    }
  }
};

// Convenience API for other scripts
PDM.recent = {
  addSlug: function(slug){ PDM.recentStorage.addToFront('slug', slug); },
  addVariant: function(savedId){ PDM.recentStorage.addToFront('variant', savedId); },
  load: function(){ return PDM.recentStorage.load(); }
};


PDM.orderStorage = {
  load: function(){
    try {
      var raw = localStorage.getItem(ORDER_STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function(x){ return x && (x.t==='slug' || x.t==='variant') && x.k; }) : [];
    } catch(e){ return []; }
  },
  save: function(list){
    try { localStorage.setItem(ORDER_STORAGE_KEY, JSON.stringify(Array.isArray(list) ? list : [])); }
    catch(e){}
  },
  addToFront: function(type, key){
    var list = this.load();
    // Remove any existing occurrence of this entry first
    list = list.filter(function(x){ return !(x && x.t===type && String(x.k).toLowerCase()===String(key).toLowerCase()); });
    // Add to the FRONT
    list.unshift({ t:type, k:String(key) });
    this.save(list);
  },
  remove: function(type, key){
    var list = this.load();
    var k = String(key).toLowerCase();
    list = list.filter(function(x){ return !(x && x.t===type && String(x.k).toLowerCase()===k); });
    this.save(list);
  }
};

  PDM.storage = {
    loadSlugs: function(){
      try {
        var raw = localStorage.getItem(GLOBAL_STORAGE_KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr.filter(Boolean) : [];
      } catch(e){ return []; }
    },
    saveSlugs: function(slugs){
      try { localStorage.setItem(GLOBAL_STORAGE_KEY, JSON.stringify(Array.from(new Set(slugs || [])))); }
      catch(e){}
    }
  };

  // Optional migration: merge any old per-context keys into the new global key
  (function migrateOldKeys(){
    var merged = new Set(PDM.storage.loadSlugs());
    ['elite','pro','performance','junior','global'].forEach(function(ctx){
      var oldKey = 'pdm_saved_v1:' + ctx;
      var raw = localStorage.getItem(oldKey);
      if (!raw) return;
      try {
        var arr = JSON.parse(raw);
        (Array.isArray(arr) ? arr : []).forEach(function(item){
          var slug = (item && typeof item === 'object') ? (item.slug || item.Slug) : item;
          if (slug) merged.add(String(slug).toLowerCase());
        });
        localStorage.removeItem(oldKey);
      } catch(e){}
    });
    PDM.storage.saveSlugs(Array.from(merged));
  })();

  // Hydrate saved Map from global slugs on load (map slugs -> full design objects if present)
  (function hydrateSavedFromSlugs(){
    var slugs = PDM.storage.loadSlugs();
    slugs.forEach(function(slug){
      var d = PDM.getDesignBySlug(slug);
      if (d) PDM.saved.set(String(slug).toLowerCase(), d);
    });
  })();

  // ===== Variant storage (Custom Stripes) ======================================
var VARIANT_STORAGE_KEY = 'pdm_saved_variants_v1';

// === Normalised keys & matching for Custom Stripes ===
// For style===2 we *ignore the middle colour* when building a key.
// We store wildcard '*' in the middle slot so "2|A|*|C".
PDM.stripeKey = function(style, A, B, C){
  var toSlug = function(x){ return (x && x.slug) ? String(x.slug).toLowerCase() : String(x||'').toLowerCase(); };
  var s = Number(style||3);
  var a = toSlug(A), b = toSlug(B), c = toSlug(C);
  if (s === 2) b = '*';
  return [s, a, b, c].join('|');
};

// Returns { exists:boolean, saved_id:string, idx:number }.
// Matches either exact saved_id or a wildcard middle ('*') when style===2.
PDM.findStripeVariant = function(style, A, B, C){
  var key = PDM.stripeKey(style, A, B, C);
  var list = PDM.variantStorage.load() || [];
  var idx = list.findIndex(function(x){ return x && x.saved_id === key; });
  if (idx >= 0) return { exists:true, saved_id:key, idx:idx };

  // Back-compat: if older saves used a concrete B for style 2, accept any B.
  if (Number(style) === 2){
    var toSlug = function(x){ return (x && x.slug) ? String(x.slug).toLowerCase() : String(x||'').toLowerCase(); };
    var a = toSlug(A), c = toSlug(C);
    var idx2 = list.findIndex(function(x){
      if (!x || !x.saved_id) return false;
      var parts = String(x.saved_id).toLowerCase().split('|'); // [style,a,b,c]
      return parts.length===4 && parts[0]==='2' && parts[1]===a && parts[3]===c;
    });
    if (idx2 >= 0) {
      return { exists:true, saved_id:list[idx2].saved_id, idx:idx2 };
    }
  }
  return { exists:false, saved_id:key, idx:-1 };
};


PDM.variantStorage = {
  load: function(){
    try {
      var raw = localStorage.getItem(VARIANT_STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch(e){ return []; }
  },
  save: function(list){
    try { localStorage.setItem(VARIANT_STORAGE_KEY, JSON.stringify(Array.isArray(list) ? list : [])); }
    catch(e){}
  }
};

// -------------------------------------------------------------
// Stripe thumbnail helpers (NO canvas / NO data URLs)
// Uses pdm-colours-json (same source of truth as modal)
// -------------------------------------------------------------
var __pdmThumbColoursMap = null;

function __pdmThumbLoadColoursMap(){
  if (__pdmThumbColoursMap) return __pdmThumbColoursMap;
  __pdmThumbColoursMap = {};
  try {
    var el = document.getElementById('pdm-colours-json');
    var arr = el ? JSON.parse((el.textContent || '').trim()) : [];
    (arr || []).forEach(function(c){
      if (!c || !c.slug) return;
      __pdmThumbColoursMap[String(c.slug).toLowerCase()] = c;
    });
  } catch(e){ __pdmThumbColoursMap = {}; }
  return __pdmThumbColoursMap;
}

function __pdmThumbResolveOverlaySrc(colour, idx, view){
  var slug = (colour && typeof colour === 'object' && colour.slug) ? colour.slug : String(colour || '');
  var map = __pdmThumbLoadColoursMap();
  var obj = map[String(slug).toLowerCase()] || null;
  if (!obj) return '';
  var key = 'stripe_' + idx + '_' + (view === 'top' ? 'top' : 'front');
  return obj[key] || '';
}


// Convenience helpers for variants
PDM.listVariants = function(){ return PDM.variantStorage.load(); };

PDM.findVariantIndex = function(saved_id){
  var list = PDM.variantStorage.load();
  var idx = list.findIndex(function(x){ return x && x.saved_id === saved_id; });
  return { list:list, idx:idx };
};

PDM.addVariant = function(obj){
  var list = PDM.variantStorage.load();
  var exists = list.some(function(x){ return x && x.saved_id === obj.saved_id; });
  if (!exists) list.unshift(obj);
  PDM.variantStorage.save(list);

  // Add to FRONT of unified order
  if (PDM.orderStorage && obj && obj.saved_id) {
    PDM.orderStorage.addToFront('variant', obj.saved_id);
  }

  if (typeof PDM.onSavedChange === 'function') PDM.onSavedChange();
};

PDM.removeVariant = function(saved_id){
  var res = PDM.findVariantIndex(saved_id);
  if (res.idx >= 0){
    res.list.splice(res.idx, 1);
    PDM.variantStorage.save(res.list);

    // Remove from unified order
    if (PDM.orderStorage) PDM.orderStorage.remove('variant', saved_id);

    if (typeof PDM.onSavedChange === 'function') PDM.onSavedChange();
    return true;
  }
  return false;
};

  // Convenience
  PDM.getSavedSlugs = function(){ return Array.from(PDM.saved.keys()); };


    // toggles and returns new state (true if saved after toggle)
  PDM.toggleSave = function(slug){
    var key = String(slug||'').toLowerCase();
    if (!key) return false;

    if (PDM.saved.has(key)){
  // REMOVE slug save
  PDM.saved.delete(key);
  if (PDM.orderStorage) PDM.orderStorage.remove('slug', key);
} else {
  var d = PDM.getDesignBySlug(key);
  if (d) {
    var savedObj = d;

    // If saving a Custom Stripes design, capture live colour-way (existing logic)
    var isStripesCustom =
      String(d.main_category || '').toLowerCase() === 'stripes' &&
      String(d.sub_category  || '').toLowerCase() === 'custom';

    if (isStripesCustom && window.PDM) {
      var summary = (typeof PDM.getStripeSummary === 'function') ? PDM.getStripeSummary(d.slug) : '';
      var st = PDM.__stripesState && String(PDM.__stripesState.slug || '').toLowerCase() === String(d.slug || '').toLowerCase()
        ? PDM.__stripesState
        : null;

      if (st) {
        var getName = (typeof PDM.getColourName === 'function') ? PDM.getColourName : function(s){ return s; };
        var toSlug = function(c){ return (c && typeof c === 'object' && c.slug) ? c.slug : String(c || ''); };
        var toName = function(c){
          if (c && typeof c === 'object') return c.name || getName(c.slug || '') || (c.slug || '');
          return getName(c) || c;
        };
        var colours = [ toName(st.A), toName(st.B), toName(st.C) ];
        var savedStyle = Number(st.style || 3);
        savedObj = Object.assign({}, d, {
        title_override: ('Saved ' + savedStyle + ' Stripes'),
        colours: colours,
        colours_slugs: [ toSlug(st.A), toSlug(st.B), toSlug(st.C) ],
        style_selected: savedStyle
        });

      } else {
        savedObj = Object.assign({}, d, { title_override: summary || '' });
      }
    }

    // ADD slug save
    PDM.saved.set(key, savedObj);
    if (PDM.orderStorage) PDM.orderStorage.addToFront('slug', key);
  }
}



      // Persist slugs only (global) — overwrite, do NOT union, so removals stick
  PDM.storage.saveSlugs(PDM.getSavedSlugs());


    if (typeof PDM.onSavedChange === 'function') PDM.onSavedChange(PDM.saved);
    updateMySavedChipIndicator && updateMySavedChipIndicator();
    return PDM.saved.has(key);
  };


  // Roots
  var root = document.getElementById('pdm-designs-root');
  var chipsBar = document.getElementById('pdm-chips');
  var sectionsRoot = document.getElementById('pdm-designs-sections');
  if (!root || !chipsBar || !sectionsRoot) { log('[PDM] root/chips/sections missing'); return; }

  // Chips
  var CATEGORY_CHIPS = [
    { key:'browse-all', label:'Browse All' },
    { key:'featured:new', label:"What's New" },
    { key:'featured:popular', label:'Most Popular' },
    { key:'featured:limited', label:'Limited Edition' },
    { key:'my-saved', label:'My Saved' },
    { key:'classic-colours', label:'Classic Colours' },
    { key:'stripes',  label:'Stripes' },
    { key:'glitter',         label:'Glitter' },
    { key:'marble',          label:'Marble' },
    { key:'special-effects', label:'Special Effects' },
    { key:'flavour-burst',   label:'Flavour Burst!™' }
  ];
 var COLOUR_CHIPS = [
    { key:'all-colours',   label:'All Colours' },
    { key:'my-saved',      label:'My Saved' },
    { key:'multi-colour',  label:'Multi-colour' },
    { key:'reds-oranges',  label:'Reds & Oranges' },
    { key:'pinks-purples', label:'Pinks & Purples' },
    { key:'greens',        label:'Greens' },
    { key:'blues',         label:'Blues' },
    { key:'neutrals',      label:'Neutrals' }
  ];

  var SUB_TITLES = {
    'classic-colours': { 'basic':'Basic', 'fluoro':'Fluoro', 'metallic':'Metallic' },
    'stripes':  { 'custom':'Custom', 'footy':'Footy', 'rugby':'Rugby', 'country':'Country' },
    'special-effects': {
      'natural-elemental':'Natural & Elemental',
      'cosmic-fantasy':'Cosmic & Fantasy',
      'abstract-dynamic':'Abstract & Dynamic'
    }
  };

  // ---------- RANK HELPERS ----------
  var BADGES_FEATURED = { new:1, popular:1, limited:1 };
  function rankOr999(v){ return (typeof v === 'number' && !isNaN(v)) ? v : 999; }
  function byName(a,b){ return String(a.name||'').localeCompare(String(b.name||'')); }
  function sortFeatured(a,b){
    var ta = rankOr999(a.featured_rank), tb = rankOr999(b.featured_rank);
    if (ta !== tb) return ta - tb;
    var ba = rankOr999(a.badge_rank),    bb = rankOr999(b.badge_rank);
    if (ba !== bb) return ba - bb;
    return byName(a,b);
  }
  function sortCategory(a,b){
    var ca = rankOr999(a.category_rank), cb = rankOr999(b.category_rank);
    if (ca !== cb) return ca - cb;
    return byName(a,b);
  }
  function sortColour(a,b){
    var ca = rankOr999(a.colour_rank), cb = rankOr999(b.colour_rank);
    if (ca !== cb) return ca - cb;
    return byName(a,b);
  }
  function sortBadgeList(a,b){
    var ba = rankOr999(a.badge_rank), bb = rankOr999(b.badge_rank);
    if (ba !== bb) return ba - bb;
    return byName(a,b);
  }

  // Helpers
  function toTitle(slug){ return (slug||'').replace(/[-_]/g,' ').replace(/\b\w/g, m => m.toUpperCase()); }

  // --- Card heart visual state helper ---
function setCardHeartState(btn, saved){
  if (!btn) return;
  btn.classList.toggle('is-active', !!saved);
  btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  var icon = btn.querySelector('i');
  if (icon){
    icon.classList.toggle('fa-regular', !saved);
    icon.classList.toggle('fa-solid',  saved);
  }
}

// Expose to other blocks (modal listener already checks for this)
window.PDM = window.PDM || {};
PDM.setCardHeartState = setCardHeartState;

// Safe CSS esc (older browsers fallback)
function pdmEscSel(s){ 
  try { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
  catch(e){ return String(s).replace(/"/g, '\\"'); }
}

// Direct handler for card-heart clicks (no delegation ambiguity)
function onCardHeartClick(e){
  e.preventDefault();
  e.stopPropagation();

  var btn  = e.currentTarget;                 // <- always the button we bound
  var slug = (btn.dataset.slug || '').toLowerCase();
  if (!slug || !window.PDM || !PDM.toggleSave) return;

  var nowSaved = PDM.toggleSave(slug);

  // 1) Update ALL card hearts with this slug immediately
  document.querySelectorAll('.pdm-card-heart[data-slug="' + pdmEscSel(slug) + '"]')
    .forEach(function(h){ setCardHeartState(h, nowSaved); });

  // 2) Mirror the modal heart if it is showing the same slug
  var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
  if (wBtn && (wBtn.dataset.slug || '').toLowerCase() === slug){
    // keep the modal's helper for its own styles
    if (typeof setWishlistButtonState === 'function') setWishlistButtonState(wBtn, nowSaved);
    // and enforce robust FA swap
    if (window.PDM && PDM.setCardHeartState) PDM.setCardHeartState(wBtn, nowSaved);
  }
}

  function createCard(d, isMySaved){
    var activeId = d['id_' + guardContext] || '';
    var cell = document.createElement('div');
    cell.className = 'pdm-designs-cell carousel-cell';
    cell.setAttribute('data-name', d.name || '');
    cell.setAttribute('data-slug', d.slug || '');
    cell.setAttribute('data-badge', d.badge || '');
    cell.setAttribute('data-creative-lab', d.creative_lab ? 'true' : 'false');
    cell.setAttribute('data-exclusive', d.exclusive ? 'true' : 'false');
    cell.setAttribute('data-main-category', (d.main_category || '').toLowerCase());
    cell.setAttribute('data-sub-category', (d.sub_category || '').toLowerCase());
    cell.setAttribute('data-colour-family', d._cfAttr || '');
    cell.setAttribute('data-img-front', d.img_front || '');
    cell.setAttribute('data-img-top', d.img_top || '');
    cell.setAttribute('data-desc', d.description || '');
    cell.setAttribute('data-id-elite', d.id_elite || '');
    cell.setAttribute('data-id-pro', d.id_pro || '');
    cell.setAttribute('data-id-performance', d.id_performance || '');
    cell.setAttribute('data-id-junior', d.id_junior || '');
    cell.setAttribute('data-id-active', activeId);

    // --- If this card represents a saved Custom Stripes variant,
    // stamp the exact saved selection onto the CELL so the modal can read it.
    if (d && d.__savedVariant && d.__savedVariant.isCustomStripes) {

  var toSlug = function (x) {
    return (x && typeof x === 'object' && x.slug) ? String(x.slug).toLowerCase()
                                                  : String(x || '').toLowerCase();
  };
  cell.setAttribute('data-saved-variant', '1');
  // Needed for Recently Viewed to record this exact saved variant
  var __sid = d.saved_id || (d.__savedVariant && d.__savedVariant.saved_id) || '';
  if (__sid) cell.setAttribute('data-saved-id', String(__sid));


  cell.setAttribute('data-saved-style', String(d.__savedVariant.style || 3));
  cell.setAttribute('data-saved-a', toSlug(d.__savedVariant.A));
  cell.setAttribute('data-saved-b', toSlug(d.__savedVariant.B));
  cell.setAttribute('data-saved-c', toSlug(d.__savedVariant.C));
}


 


    var card = document.createElement('div');
card.className = 'pdm-designs-card';

var thumb = document.createElement('div');
thumb.className = 'pdm-designs-thumb';

// Make thumbnail clickable to open the design modal (same handler as "View design").
// The modal script listens for [data-open-design].
thumb.setAttribute('data-open-design', 'true');
thumb.setAttribute('role', 'button');
thumb.setAttribute('tabindex', '0');
thumb.style.cursor = 'pointer';

// Keyboard support (Enter/Space triggers click)
thumb.addEventListener('keydown', function(e){
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    thumb.click();
  }
});


var mainCat = String(d.main_category || '').toLowerCase();
var subCat  = String(d.sub_category  || '').toLowerCase();
var slugLC  = String(d.slug || '').toLowerCase();

// These two “entry” cards must remain unchanged (still use JSON img src)
// Treat custom-2/custom-3 as "entry cards" ONLY when they are not a saved variant.
// Saved custom stripes may still carry the same slug, but should render as layered thumbs.
var isCustomStripeBaseCard =
  /^(custom-2-stripes|custom-3-stripes)$/i.test(slugLC) &&
  !(d && d.__savedVariant && d.__savedVariant.isCustomStripes);



// Stripe designs (presets + My Saved variants) render as: base-top + overlay(s)
var shouldRenderStripeThumb =
  (mainCat === 'stripes') &&
  !isCustomStripeBaseCard;

// Default single-image thumb (non-stripes + the two custom entry cards)
function renderSingleImg(src){
  var img = document.createElement('img');
  img.src = src || '';
  img.alt = (d.name || '') + ' mouthguard';
  img.loading = 'lazy';
  thumb.appendChild(img);
}

function renderSingleImgInTopviewInner(src){
  thumb.style.position = 'relative';
  thumb.classList.add('pdm-thumb--topview');

  var tInner = document.createElement('div');
  tInner.className = 'pdm-thumb__inner';

  var img = document.createElement('img');
  img.src = src || '';
  img.alt = (d.name || '') + ' mouthguard';
  img.loading = 'lazy';

  tInner.appendChild(img);
  thumb.appendChild(tInner);
}


if (!shouldRenderStripeThumb) {
  // Apply top-view scaling wrapper for the two custom entry cards as well
  if (isCustomStripeBaseCard) {
    renderSingleImgInTopviewInner(d.img_front || d.img || '');
  } else {
    renderSingleImg(d.img_front || d.img || '');
  }
} else {

    // Layered stripes thumbnail: base top + overlays (NO canvas)
  thumb.style.position = 'relative';
  thumb.classList.add('pdm-thumb--topview');

  // Inner wrapper so we can scale TOP view without affecting layout footprint
  var tInner = document.createElement('div');
  tInner.className = 'pdm-thumb__inner';

  var baseSrc = (window.PDM_CONFIG && window.PDM_CONFIG.stripes_base_top)
    ? window.PDM_CONFIG.stripes_base_top
    : (d.img_top || d.img_front || d.img || '');

  var baseImg = document.createElement('img');
  baseImg.src = baseSrc || '';
  baseImg.alt = (d.name || '') + ' mouthguard';
  baseImg.loading = 'lazy';

  tInner.appendChild(baseImg);
  thumb.appendChild(tInner);


  // Determine stripe colours/style:
  var style = 3;
  var A = '', B = '', C = '';

  // Saved custom-stripe variant (stored on the object)
  if (d.__savedVariant && d.__savedVariant.isCustomStripes) {
    style = Number(d.__savedVariant.style || 3);

    var toSlug = function (x) {
      return (x && typeof x === 'object' && x.slug) ? String(x.slug).toLowerCase()
                                                    : String(x || '').toLowerCase();
    };

    A = toSlug(d.__savedVariant.A || '');
    B = toSlug(d.__savedVariant.B || '');
    C = toSlug(d.__savedVariant.C || '');
  }

  // Preset stripe design (supports_stripes + default_* fields)
  else if (d.supports_stripes) {
    style = Number(d.default_style || 3);
    var arr = Array.isArray(d.default_colours) ? d.default_colours : [];
    if (style === 2) {
      A = arr[0] || '';
      C = arr[1] || '';
      B = ''; // no middle stripe in 2-stripe
    } else {
      A = arr[0] || '';
      B = arr[1] || '';
      C = arr[2] || '';
    }
  }

  function addOverlay(src){
    if (!src) return;
    var o = document.createElement('img');
    o.src = src;
    o.alt = '';
    o.loading = 'lazy';
    o.setAttribute('aria-hidden','true');
    o.style.position = 'absolute';
    o.style.left = '0';
    o.style.top = '0';
    o.style.width = '100%';
    o.style.height = '100%';
    o.style.pointerEvents = 'none';
    tInner.appendChild(o);
  }

  // Match existing render order: 1, 3, then 2 on top (for 3-stripe)
  addOverlay(__pdmThumbResolveOverlaySrc(A, 1, 'top'));
  addOverlay(__pdmThumbResolveOverlaySrc(C, 3, 'top'));
  if (style === 3) addOverlay(__pdmThumbResolveOverlaySrc(B, 2, 'top'));
}



// ---- Heart (save/remove) button ----
var slug = String(d.slug || '').toLowerCase();
var isCustomStripeBase = /^(custom-2-stripes|custom-3-stripes)$/i.test(slug);
var isSavedStripeVariant = !!(d && d.__savedVariant && d.__savedVariant.isCustomStripes && d.saved_id);
var shouldShowHeart = !isCustomStripeBase || isMySaved || isSavedStripeVariant;


if (shouldShowHeart) {
  var heartBtn = document.createElement('button');
  heartBtn.type = 'button';
  heartBtn.className = 'pdm-card-heart';
  heartBtn.setAttribute('aria-label', 'Save design');
  heartBtn.setAttribute('aria-pressed', 'false');

    // If this is a saved Custom Stripes variant (My Saved OR Recently Viewed),
    // show it as saved only if it still exists in storage.
    var _variantIsActuallySaved = false;
    try {
    if (window.PDM && PDM.findVariantIndex && d && d.saved_id) {
        _variantIsActuallySaved = (PDM.findVariantIndex(d.saved_id).idx >= 0);
    }
    } catch(e) { _variantIsActuallySaved = false; }

    if (d && d.__savedVariant && d.__savedVariant.isCustomStripes && d.saved_id && _variantIsActuallySaved) {
        // Saved variant: clicking removes this exact variant
        heartBtn.dataset.savedId = d.saved_id;
        heartBtn.innerHTML = '<i class="fa-solid fa-heart" aria-hidden="true"></i>';
        heartBtn.classList.add('is-active');
        heartBtn.setAttribute('aria-pressed', 'true');

    } else if (d && d.__savedVariant && d.__savedVariant.isCustomStripes && d.saved_id && !_variantIsActuallySaved) {
        // RV reconstructed (or otherwise unsaved) variant: show UNSAVED state,
        // but allow re-save of this exact variant using variantKey flow.
        heartBtn.dataset.variantKey = d.saved_id;
        heartBtn.dataset.slug = d.slug || '';
        heartBtn.innerHTML = '<i class="fa-regular fa-heart" aria-hidden="true"></i>';
        heartBtn.classList.remove('is-active');
        heartBtn.setAttribute('aria-pressed', 'false');

    } else {


    // Normal designs (and non-variant entries)
    heartBtn.dataset.slug = d.slug || '';
    heartBtn.innerHTML = '<i class="fa-regular fa-heart" aria-hidden="true"></i>';

        if (window.PDM && PDM.isSaved && d.slug) {
            setCardHeartState(heartBtn, !!PDM.isSaved(d.slug));
        }
    }


  thumb.appendChild(heartBtn);

  // Bind click
  heartBtn.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();

    var sid = this.dataset.savedId || '';
    if (sid && window.PDM && PDM.removeVariant) {
    // remove this exact variant, then refresh My Saved
    PDM.removeVariant(sid);

    // Only short-circuit / re-render when this heart belongs to a My Saved card.
    // (Recently Viewed should keep the card and just flip the heart state.)
    if (isMySaved && PDM.getSelectedKey && PDM.getSelectedKey()==='my-saved' &&
    typeof PDM.forceRender === 'function') {

    // Mirror to any other hearts for this exact saved variant (e.g. Recently Viewed)
    try {
      var sid2 = String(sid || '');
      var slug2 = String(d.slug || '').toLowerCase();

      document.querySelectorAll('.pdm-card-heart[data-saved-id="' + sid2.replace(/"/g,'\\"') + '"]')
        .forEach(function(h){
          // flip visual state
          setCardHeartState(h, false);

          // allow RV to re-save the same variant next click
          h.dataset.variantKey = sid2;
          delete h.dataset.savedId;
          h.dataset.slug = slug2;
        });
    } catch(e) {}

    PDM.forceRender();
    PDM.toast('Removed from My Saved');
    return;
}


    // fallback: flip the heart only
this.classList.remove('is-active');

  this.setAttribute('aria-pressed','false');
  var i = this.querySelector('i');
  if (i) { i.classList.remove('fa-solid'); i.classList.add('fa-regular'); }

  // IMPORTANT: switch this heart from variant-mode to slug-mode so next click can re-save
  try {
    delete this.dataset.savedId;               // removes data-saved-id
    this.dataset.slug = (d.slug || '');        // adds data-slug for legacy toggle
  } catch(e) {}

  // mirror all hearts for this slug (so RV + anywhere else stay consistent)
  var s2 = ((d.slug || '') + '').toLowerCase();
  if (s2) {
    document.querySelectorAll('.pdm-card-heart[data-slug="' + pdmEscSel(s2) + '"]')
      .forEach(function(h){ setCardHeartState(h, false); });
  }

  PDM.toast('Removed from My Saved');
  // Cache this exact variant so RV can re-save the same stripes on next click
this.dataset.variantKey = sid;

// Switch out of variant-mode so we don't keep hitting removeVariant() forever
delete this.dataset.savedId;

// Keep a slug for normal behaviour elsewhere (optional, but harmless)
this.dataset.slug = (d.slug || '');

  return;

    }


    // Re-save a previously removed saved-stripe variant from Recently Viewed
var vk = this.dataset.variantKey || '';
if (!sid && vk && window.PDM && PDM.addVariant && d && d.__savedVariant && d.__savedVariant.isCustomStripes) {
  var style = Number(d.__savedVariant.style || 3);
  var A = d.__savedVariant.A, B = d.__savedVariant.B, C = d.__savedVariant.C;

  // Recompute saved_id (2-stripe uses '*' middle via stripeKey)
  var saved_id = (PDM.stripeKey ? PDM.stripeKey(style, A, B, C) : vk);

  var savedObj = Object.assign({}, d, {
    slug: d.slug,
    title_override: ('Saved ' + style + ' Stripes'),
    __savedVariant: { isCustomStripes:true, style:style, A:A, B:B, C:C },
    saved_id: saved_id
  });

  try { PDM.addVariant(savedObj); } catch(e) {}

  // Update this heart back to "saved variant" mode
  this.classList.add('is-active');
  this.setAttribute('aria-pressed','true');
  var ii = this.querySelector('i');
  if (ii) { ii.classList.remove('fa-regular'); ii.classList.add('fa-solid'); }

  this.dataset.savedId = saved_id;
  delete this.dataset.slug;

  PDM.toast('Added to My Saved');
  return;
}


    // legacy slug save toggle
    var s = (this.dataset.slug || '').toLowerCase();
    if (!s || !window.PDM || !PDM.toggleSave) return;
    var nowSaved = PDM.toggleSave(s);
    PDM.toast(nowSaved ? 'Added to My Saved' : 'Removed from My Saved');

    // mirror all hearts for this slug
    document.querySelectorAll('.pdm-card-heart[data-slug="' + pdmEscSel(s) + '"]')
      .forEach(function(h){ setCardHeartState(h, nowSaved); });
      // If user is currently viewing My Saved (in any mode), refresh the carousel
    if (!nowSaved && PDM.getSelectedKey && PDM.getSelectedKey() === 'my-saved' &&
        typeof PDM.forceRender === 'function') {
    updateMySavedChipIndicator();
    PDM.forceRender();
    }


    // mirror modal heart if same slug is open
    var wBtn = document.querySelector('#pdm-design-modal .pdm-wishlist-btn');
    if (wBtn && (wBtn.dataset.slug || '').toLowerCase() === s){
      if (typeof setWishlistButtonState === 'function') setWishlistButtonState(wBtn, nowSaved);
      if (window.PDM && PDM.setCardHeartState) PDM.setCardHeartState(wBtn, nowSaved);
    }
  }, false);
}




    // Show badges normally, EXCEPT for saved Custom Stripes inside "My Saved"
(function(){
  var hasBadge = d.badge && String(d.badge).trim();
  if (!hasBadge) return;

  var isStripesCustom =
    String(d.main_category || '').toLowerCase() === 'stripes' &&
    String(d.sub_category  || '').toLowerCase() === 'custom';

 // In "My Saved":
// - Hide badge for saved CUSTOM STRIPES variants
// - Keep badge for preset stripes (even when saved)
if (d && d.__savedVariant && d.__savedVariant.isCustomStripes) return;

// (Optional safety) still suppress badge for the base custom entry cards if they ever have a badge
if (isMySaved && isStripesCustom && !(d && d.__savedVariant)) return;


  var badgeVal = String(d.badge).toLowerCase().trim();
  var badgeEl  = document.createElement('span');
  badgeEl.className = 'pdm-designs-badge';
  badgeEl.textContent = badgeVal.toUpperCase();
  badgeEl.setAttribute('data-badge', badgeVal);
  card.appendChild(badgeEl);
})();


    var info = document.createElement('div');
    info.className = 'pdm-designs-info';

    var title = document.createElement('div');
title.className = 'pdm-designs-title';

// If we’re rendering the My Saved carousel and this is a custom stripes design,
// prefer the saved colour-way as the card title (title_override), else fall back.
var isStripesCustom =
  String(d.main_category || '').toLowerCase() === 'stripes' &&
  String(d.sub_category  || '').toLowerCase() === 'custom';

// Saved custom stripes variants: make it explicit
if (d && d.__savedVariant && d.__savedVariant.isCustomStripes) {
  var ss = Number(d.__savedVariant.style || 3);
  title.textContent = 'Saved ' + ss + ' Stripes';

// Otherwise: in My Saved for the base Custom Stripes designs, prefer title_override if present
} else if (isMySaved && isStripesCustom && d.title_override) {
  title.textContent = d.title_override;

} else {
  title.textContent = d.name || '';
}


info.appendChild(title);


    var btnWrap = document.createElement('div');
    btnWrap.className = 'pdm-designs-btn';

    var btn = document.createElement('a');
    btn.href = 'javascript:;';
    btn.className = 'action_button highlight-false';
    btn.textContent = 'View design';

    var slugLC = String(d.slug || '').toLowerCase();
    var isSavedStripeVariant = !!(d && d.__savedVariant && d.__savedVariant.isCustomStripes);

    // Generic base Custom Stripes entry cards (Category + RV): rainbow + "Customise"
    // Saved stripe variants (My Saved + RV): rainbow + "View design"
    var isCustomStripesBase = !isMySaved && !isSavedStripeVariant &&
    (slugLC === 'custom-2-stripes' || slugLC === 'custom-3-stripes');

    var useRainbow = isCustomStripesBase || isSavedStripeVariant;

    if (useRainbow) {
    if (isCustomStripesBase) btn.textContent = 'Customise';
    else btn.textContent = 'View design';

    // Wrap in a rainbow frame
    var wrap = document.createElement('span');
    wrap.className = 'pdm-rainbow-wrap';
    wrap.appendChild(btn);
    btnWrap.appendChild(wrap);
    } else {
    // Normal cards
    btnWrap.appendChild(btn);
    }



    card.appendChild(thumb);
    card.appendChild(info);
    card.appendChild(btnWrap);
    cell.appendChild(card);
    return cell;
  }

  // CreativeLab CTA card
function createRequestCard(){
  var labmarkSrc = window.PDM_CONFIG.labmarkSrc;

  var cell = document.createElement('div');
  cell.className = 'pdm-designs-cell carousel-cell pdm-designs-cell--cta';

  var card = document.createElement('div');
  card.className = 'pdm-designs-card pdm-designs-card--cta';

  var logo = document.createElement('img');
  logo.className = 'pdm-cta-logo';
  logo.src = labmarkSrc;
  logo.alt = 'Smileflex CreativeLab';
  card.appendChild(logo);

  var title = document.createElement('div');
  title.className = 'pdm-cta-title';
  title.textContent = 'Have an idea for a design?';
  card.appendChild(title);

  var sub = document.createElement('div');
  sub.className = 'pdm-cta-sub';
  sub.textContent = 'Tell our CreativeLab™ and we might just bring it to life!';
  card.appendChild(sub);

  var actions = document.createElement('div');
  actions.className = 'pdm-cta-actions';
  var btn = document.createElement('a');
  btn.href = '/pages/creativelab#request';
  btn.target = '_blank';
  btn.rel = 'noopener noreferrer';
  btn.className = 'action_button highlight-true';
  btn.textContent = 'Request design';
  actions.appendChild(btn);
  card.appendChild(actions);

  cell.appendChild(card);
  return cell;
}

  // Flickity init
  function initFlickity(elem){
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.flickity) return;
    var mq = window.matchMedia('(max-width: 640px)');
    var $el = jQuery(elem);
    var inst = $el.data('flickity');
    if (!inst) {
      $el.flickity({
        freeScroll: true,
        freeScrollFriction: 0.015,
        wrapAround: true,
        dragThreshold: 10,
        contain: true,
        pageDots: false,
        cellAlign: mq.matches ? 'center' : 'left'
      });
      inst = $el.data('flickity');
    }
    function applyAlign(){
      if (!inst) return;
      var desired = mq.matches ? 'center' : 'left';
      if (inst.options.cellAlign !== desired) {
        inst.options.cellAlign = desired;
        inst.resize();
        inst.select(inst.selectedIndex, false, true);
      }
    }
    applyAlign();
    if (!elem._pdmAlignBound) {
      (mq.addEventListener ? mq.addEventListener('change', applyAlign) : mq.addListener(applyAlign));
      elem._pdmAlignBound = true;
    }
  }

  function makeCarouselSection(parentEl, title, subtitle, items){
    if (!items || !items.length) return null;

    var sec = document.createElement('section');
    sec.className = 'pdm-section';

    var head = document.createElement('div');
    head.className = 'pdm-section__head';
    if (title === 'Flavour Burst') title = 'Smileflex® Flavour Burst!™';
    head.innerHTML =
      '<div><div class="pdm-section__title">'+(title||'')+'</div>' +
      (subtitle ? '<div class="pdm-section__subtitle">'+subtitle+'</div>' : '') +
      '</div>';
    sec.appendChild(head);

    var wrap = document.createElement('div');
    wrap.className = 'pdm-designs-carousel';
    sec.appendChild(wrap);

    var isMySavedSection = (title === 'My Saved');
items.forEach(function(d){
  wrap.appendChild(createCard(d, isMySavedSection));
});


    // Append CTA card to all carousels except "My Saved" and "Recently viewed"
    var t = String(title || '').toLowerCase();
    if (t !== 'my saved' && t !== 'recently viewed') {
    wrap.appendChild(createRequestCard());
    }


    parentEl.appendChild(sec);
    initFlickity(wrap);

    wrap.querySelectorAll('img').forEach(function(im){
      if (im.complete) {
        if (window.jQuery) { var inst = jQuery(wrap).data('flickity'); if (inst) { inst.reloadCells(); inst.resize(); } }
      } else {
        im.addEventListener('load', function(){
          if (window.jQuery) { var inst = jQuery(wrap).data('flickity'); if (inst) { inst.reloadCells(); inst.resize(); } }
        });
      }
    });

    return sec;
  }

  function limitSections(groupEl, limit, buttonLabel){
    var sections = Array.from(groupEl.querySelectorAll(':scope > .pdm-section'));
    if (sections.length <= limit) return;

    sections.forEach(function(sec, i){
      if (i >= limit) sec.classList.add('pdm-sec-hidden');
    });

    var more = document.createElement('div');
    more.className = 'pdm-group-more';
    more.innerHTML = '<button type="button">'+(buttonLabel || 'View more')+'</button>';
    groupEl.appendChild(more);

    more.querySelector('button').addEventListener('click', function(){
      sections.forEach(function(sec){
        sec.classList.remove('pdm-sec-hidden');
        var wrap = sec.querySelector('.pdm-designs-carousel');
        if (!wrap) return;

        if (window.jQuery) {
          var inst = jQuery(wrap).data('flickity');
          if (inst) { inst.reloadCells(); inst.resize(); }
          else { initFlickity(wrap); inst = jQuery(wrap).data('flickity'); if (inst){ inst.reloadCells(); inst.resize(); } }
        } else {
          initFlickity(wrap);
        }

        wrap.querySelectorAll('img').forEach(function(im){
          if (im.complete) {
            if (window.jQuery) { var inst2 = jQuery(wrap).data('flickity'); if (inst2) { inst2.reloadCells(); inst2.resize(); } }
          } else {
            im.addEventListener('load', function(){
              if (window.jQuery) { var inst3 = jQuery(wrap).data('flickity'); if (inst3) { inst3.reloadCells(); inst3.resize(); } }
            });
          }
        });
      });
      more.remove();
    });
  }

    function updateMySavedChipIndicator(){
  var chip = document.querySelector('.pdm-chip[data-key="my-saved"]');
  if (!chip) return;
  // We’re keeping the dot always visible via CSS.
  // Don’t toggle .has-items and don’t reflect saved-count in aria here.
  chip.classList.remove('has-items');
  chip.setAttribute('aria-pressed', 'false'); // pressed state is for selection, not save-count
}

  // Run once after initial hydration
  updateMySavedChipIndicator();


  // Chip UI
  var mode = 'category';
  var selectedKey = 'browse-all';
  PDM.getMode = function(){ return mode; };
  PDM.getSelectedKey = function(){ return selectedKey; };

  var toggleBtns = root.querySelectorAll('.pdm-toggle__btn');
  toggleBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var newMode = btn.getAttribute('data-mode');
      if (!newMode || newMode === mode) return;
      mode = newMode;
      toggleBtns.forEach(function(b){ b.classList.toggle('is-active', b === btn); b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
      selectedKey = (mode === 'category') ? 'browse-all' : 'all-colours';
      buildChips();
      render();
    });
  });

  // === Chip visibility helpers ===
function hasDesignsForCategoryKey(key){
  var k = String(key||'').toLowerCase();

  // Always keep these entry points
  if (k === 'browse-all' || k === 'my-saved') return true;

  // Featured chips (only show if at least one design has that badge)
  if (k.indexOf('featured:') === 0){
    var t = k.split(':')[1];
    return designs.some(function(d){
      return String(d.badge || '').toLowerCase().trim() === t;
    });
  }

  // Main categories (show only if any design matches that main_category)
  return designs.some(function(d){
    return String(d.main_category || '').toLowerCase() === k;
  });
}

function hasDesignsForColourKey(key){
  var k = String(key||'').toLowerCase();
  if (k === 'all-colours') return true;

  // Always keep "My Saved" visible in colour mode (even if empty)
  if (k === 'my-saved') return true;


  return designs.some(function(d){
    var main = String(d.main_category || '').toLowerCase();
    var slug = String(d.slug || '').toLowerCase();

    // Exclude ALL stripes from colour mode, EXCEPT some presets
    var isStripesExemption = (main === 'stripes' && slug !== 'indigenous' && slug !== 'australia');
    if (isStripesExemption) return false;

    return PDM.hasColourFamily(d, k);
  });
}



  function buildChips(){
  chipsBar.innerHTML = '';
  var defs = (mode === 'category') ? CATEGORY_CHIPS : COLOUR_CHIPS;

  // Filter out chips that currently have zero designs
  var filtered = defs.filter(function(def){
    return (mode === 'category')
      ? hasDesignsForCategoryKey(def.key)
      : hasDesignsForColourKey(def.key);
  });

  // If the current selection is now hidden, fall back to a safe default
  var fallback = (mode === 'category') ? 'browse-all' : 'all-colours';
  var keys = filtered.map(function(d){ return d.key; });
  if (keys.indexOf(selectedKey) === -1){
    selectedKey = (keys.indexOf(fallback) >= 0) ? fallback : (keys[0] || fallback);
  }

  filtered.forEach(function(def){
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'pdm-chip' + (def.key === selectedKey ? ' is-active' : '');
    chip.dataset.key = def.key;
    chip.textContent = def.label;
    chip.addEventListener('click', function(){
      if (selectedKey === def.key) return;
      selectedKey = def.key;
      chipsBar.querySelectorAll('.pdm-chip').forEach(function(c){
        c.classList.toggle('is-active', c.dataset.key === selectedKey);
      });
      render();
    });
    chipsBar.appendChild(chip);
  });
}


  function renderMySavedSection(){
  sectionsRoot.innerHTML = '';

  // Build maps for quick lookup
var slugMap = new Map(); // slug -> design obj
Array.from(PDM.saved.entries()).forEach(function(pair){
  var k = String(pair[0] || '').toLowerCase();
  var v = pair[1];
  if (k && v) slugMap.set(k, v);
});

var variantList = (PDM.listVariants ? PDM.listVariants() : []).map(function(v){
  return Object.assign(
    {
      name: v.name || v.title_override || 'Custom Stripes',
      slug: v.slug || '',
      badge: v.badge || '',
      creative_lab: !!v.creative_lab,
      main_category: 'stripes',
      sub_category: 'custom',
      colour_family: 'multi-colour',
      img_front: v.img_front || '',
      img_top: v.img_top || '',
      description: v.description || '',
      id_elite: v.id_elite || '',
      id_pro: v.id_pro || '',
      id_performance: v.id_performance || '',
      id_junior: v.id_junior || ''
    },
    v
  );
});
var variantMap = new Map(); // saved_id -> variant obj
variantList.forEach(function(v){ if (v && v.saved_id) variantMap.set(String(v.saved_id), v); });

// Follow unified order newest-first
var ordered = [];
var order = (PDM.orderStorage ? PDM.orderStorage.load() : []) || [];
order.forEach(function(entry){
  if (!entry || !entry.t || !entry.k) return;
  if (entry.t === 'slug') {
    var d = slugMap.get(String(entry.k).toLowerCase());
    if (d) ordered.push(d);
  } else if (entry.t === 'variant') {
    var vv = variantMap.get(String(entry.k));
    if (vv) ordered.push(vv);
  }
});

// Fallbacks: include anything missing from order (should be rare)
slugMap.forEach(function(v, k){
  if (!ordered.some(function(x){ return x === v; })) ordered.push(v);
});
variantMap.forEach(function(v, k){
  if (!ordered.some(function(x){ return x && x.saved_id && v && x.saved_id === v.saved_id; })) ordered.push(v);
});

if (!ordered.length){
  var empty = document.createElement('section');
  empty.className = 'pdm-section';
  empty.innerHTML =
    '<div class="pdm-section__head"><div>' +
    '<div class="pdm-section__title">My Saved</div></div></div>' +
    '<p style="margin:8px 4px 0;color:#666;">You haven’t saved any designs yet. Tap the heart in a design to add it here.</p>';
  sectionsRoot.appendChild(empty);
  return;
}

makeCarouselSection(sectionsRoot, 'My Saved', '', ordered);

}

  // Render
  function render(){
    sectionsRoot.innerHTML = '';

    // My Saved (available in both category + colour modes)
    if (selectedKey === 'my-saved'){
      renderMySavedSection();
      return;
    }


    if (mode === 'category') {
      if (selectedKey === 'browse-all') {
        var featured = designs.filter(function(d){
          var b = String(d.badge || '').toLowerCase().trim();
          return !!BADGES_FEATURED[b];
        }).sort(sortFeatured);
        if (featured.length) {
          makeCarouselSection(sectionsRoot, 'Featured', '', featured);
        }

        var group = document.createElement('div');
        sectionsRoot.appendChild(group);
        renderAllMainCategories(group, true);
        limitSections(group, 4, 'View more categories');
        return;
      }

      if (selectedKey.indexOf('featured:') === 0) {
        var t = selectedKey.split(':')[1];
        var label = (t === 'new') ? "What's New" : (t === 'popular' ? 'Most Popular' : 'Limited Edition');
        var filtered = designs.filter(function(d){ return (String(d.badge || '').toLowerCase().trim() === t); })
                              .sort(sortBadgeList);
        makeCarouselSection(sectionsRoot, label, '', filtered);
        return;
      }

      renderOneMainCategory(sectionsRoot, selectedKey);
      return;
    }

    // Mode: colour
    if (selectedKey === 'all-colours') {
  var group2 = document.createElement('div');
  sectionsRoot.appendChild(group2);
  COLOUR_CHIPS.forEach(function(c){
    if (c.key === 'all-colours') return;

    var items = designs.filter(function(d){
      var main = String(d.main_category || '').toLowerCase();
      var slug = String(d.slug || '').toLowerCase();

      // Exclude all stripes EXCEPT some presets
      var isStripesExemption = (main === 'stripes' && slug !== 'indigenous' && slug !== 'australia');
      if (isStripesExemption) return false;

      return PDM.hasColourFamily(d, c.key);
    }).sort(sortColour);

    makeCarouselSection(group2, c.label, '', items);
  });
  limitSections(group2, 4, 'View more colours');
} else {
  var cfg = COLOUR_CHIPS.find(function(c){return c.key===selectedKey;});
  var items2 = designs.filter(function(d){
    var main = String(d.main_category || '').toLowerCase();
    var slug = String(d.slug || '').toLowerCase();

    // Exclude all stripes EXCEPT some presets
    var isStripesExemption = (main === 'stripes' && slug !== 'indigenous' && slug !== 'australia');
    if (isStripesExemption) return false;

    return PDM.hasColourFamily(d, selectedKey);
  }).sort(sortColour);

  makeCarouselSection(sectionsRoot, cfg ? cfg.label : toTitle(selectedKey), '', items2);
}
  }

  function renderAllMainCategories(parentGroup, condense){
    CATEGORY_CHIPS.forEach(function(c){
      if (c.key === 'browse-all' || c.key.indexOf('featured:') === 0 || c.key === 'my-saved') return;
      var mk = String(c.key || '').toLowerCase();
      var items = designs.filter(function(d){ return String(d.main_category || '').toLowerCase() === mk; });
      if (!items.length) return;
      items.sort(sortCategory);

      var subMap = SUB_TITLES[mk] || null;
      if (subMap && condense) {
        // Browse All (condensed): one carousel per main category, include all its sub-categories
        items.sort(sortCategory);
        makeCarouselSection(parentGroup, toTitle(mk), '', items);
      } else if (subMap) {
        // Normal behaviour: separate carousels per sub-category
        var anySub = false;
        Object.keys(subMap).forEach(function(subKey){
          var group = items.filter(function(d){
            return String(d.sub_category || '').toLowerCase() === subKey;
          });
          if (group.length) {
            group.sort(sortCategory);
            anySub = true;
            makeCarouselSection(parentGroup, toTitle(mk) + ' – ' + subMap[subKey], '', group);
          }
        });
        if (!anySub) {
          makeCarouselSection(parentGroup, toTitle(mk), '', items);
        }
      } else {
        // Categories with no sub-categories (e.g., Glitter, Marble)
        makeCarouselSection(parentGroup, toTitle(mk), '', items);
      }
    });
  }

  function renderOneMainCategory(parent, mainKey){
    var mk = String(mainKey || '').toLowerCase();
    var items = designs.filter(function(d){ return String(d.main_category || '').toLowerCase() === mk; });
    if (!items.length) return;
    items.sort(sortCategory);

    var subMap = SUB_TITLES[mk] || null;
    if (subMap) {
      var anySub = false;
      Object.keys(subMap).forEach(function(subKey){
        var group = items.filter(function(d){ return String(d.sub_category || '').toLowerCase() === subKey; });
        if (group.length) { anySub = true; group.sort(sortCategory); makeCarouselSection(parent, toTitle(mk) + ' – ' + subMap[subKey], '', group); }
      });
      if (!anySub) makeCarouselSection(parent, toTitle(mk), '', items);
    } else {
      makeCarouselSection(parent, toTitle(mk), '', items);
    }
  }

  // let other scripts request a refresh after save changes
  PDM.forceRender = function(){ render(); };

  // if saves change while My Saved is shown, refresh automatically
  PDM.onSavedChange = function(){
     if (PDM.getSelectedKey && PDM.getSelectedKey()==='my-saved'){
        render();
     }
  };


    // Cross-tab & cross-page sync of GLOBAL list
  window.addEventListener('storage', function(e){
  // React to slugs OR order changes
  if (e.key !== GLOBAL_STORAGE_KEY && e.key !== ORDER_STORAGE_KEY && e.key !== RECENT_STORAGE_KEY) return;
    // Rehydrate Map from latest global slugs
    PDM.saved.clear();
    (PDM.storage.loadSlugs() || []).forEach(function(slug){
      var d = PDM.getDesignBySlug(slug);
      if (d) PDM.saved.set(String(slug).toLowerCase(), d);
    });
    updateMySavedChipIndicator();
    if (PDM.forceRender) PDM.forceRender();
    if (PDM.renderRecentlyViewed) PDM.renderRecentlyViewed();

  });


  // Init
  buildChips();
  render();


  // Recently Viewed block (single carousel)
  PDM.renderRecentlyViewed = function(){

    // Support multiple instances:
    // Preferred: blocks marked with [data-pdm-recently-viewed]
    var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-pdm-recently-viewed]') || []);

    // Back-compat: legacy single-instance IDs
    if (!blocks.length) {
      var legacyWrap = document.getElementById('pdm-recently-viewed-wrap');
      if (legacyWrap) blocks = [legacyWrap];
    }

    if (!blocks.length) return;

    // Styling rule: only the first instance gets no top padding (no markup changes required)
    try {
      if (blocks[0]) blocks[0].style.paddingTop = '0px';
    } catch (e) {}

    // Build list from storage
    var list = (window.PDM && PDM.recent && PDM.recent.load) ? PDM.recent.load() : [];

    // If nothing to show, hide all instances
    if (!list.length) {
      blocks.forEach(function(b){
        var rootEl = b.querySelector('.pdm-recently-viewed-root') || document.getElementById('pdm-recently-viewed-root');
        if (rootEl) rootEl.style.display = 'none';
        b.style.display = 'none';
      });
      return;
    }

    // Resolve to card models
    var out = [];
    var variants = (window.PDM && PDM.variantStorage && PDM.variantStorage.load) ? (PDM.variantStorage.load() || []) : [];

    list.forEach(function(entry){
        if (!entry || !entry.t || !entry.k) return;

        if (entry.t === 'slug') {
        var d = (window.PDM && PDM.getDesignBySlug) ? PDM.getDesignBySlug(entry.k) : null;
        if (d) out.push(d);
        return;
        }

        if (entry.t === 'variant') {
        var sid = String(entry.k || '');
        var v = variants.find(function(x){ return x && String(x.saved_id || '').toLowerCase() === sid.toLowerCase(); });

        // Keep RV entries even if no longer saved: reconstruct from the key string.
        if (!v) {
          var parts = sid.split('|');
          var sStyle = Number(parts[0] || 3);
          var sA = String(parts[1] || '');
          var sB = String(parts[2] || '');
          var sC = String(parts[3] || '');

          v = {
            saved_id: sid,
            __savedVariant: { isCustomStripes:true, saved_id:sid, style:sStyle, A:sA, B:sB, C:sC }
          };
        }

        // Create a design-ish object like My Saved does (so thumbs render correctly)
        // NOTE: saved variants store stripe data under __savedVariant in this ZIP.
        var sv = (v && v.__savedVariant && v.__savedVariant.isCustomStripes) ? v.__savedVariant : v;



        var svStyle = Number((sv && sv.style) || 3);
        var baseSlug = (svStyle === 2) ? 'custom-2-stripes' : 'custom-3-stripes';
        var base = (window.PDM && PDM.getDesignBySlug) ? PDM.getDesignBySlug(baseSlug) : null;
        if (!base) return;

        var clone = Object.assign({}, base);
        clone.saved_id = v.saved_id;
        clone.__savedVariant = {
            isCustomStripes: true,
            saved_id: v.saved_id,
            style: svStyle,
            A: (sv && sv.A) || '',
            B: (sv && sv.B) || '',
            C: (sv && sv.C) || ''
        };

        out.push(clone);

        }
    });

    if (!out.length) {
      rvRoot.style.display = 'none';
      if (rvWrap) rvWrap.style.display = 'none';
      return;
    }

    // If nothing resolved, hide all instances
    if (!out.length) {
      blocks.forEach(function(b){
        var rootEl = b.querySelector('.pdm-recently-viewed-root') || document.getElementById('pdm-recently-viewed-root');
        if (rootEl) rootEl.style.display = 'none';
        b.style.display = 'none';
      });
      return;
    }

    // Render into every instance
    blocks.forEach(function(b){
      var rvRoot = b.querySelector('.pdm-recently-viewed-root') || document.getElementById('pdm-recently-viewed-root');
      var rvSections = b.querySelector('.pdm-recently-viewed-sections') || document.getElementById('pdm-recently-viewed-sections');

      if (!rvRoot || !rvSections) return;

      rvSections.innerHTML = '';
      makeCarouselSection(rvSections, 'Recently Viewed', '', out);

      rvRoot.style.display = '';
      b.style.display = '';
    });

    };


    // Render Recently Viewed after DOM is ready (block may be further down the page)
    document.addEventListener('DOMContentLoaded', function(){
    if (PDM.renderRecentlyViewed) PDM.renderRecentlyViewed();
    });

    // Also attempt immediately + retry briefly (covers cases where the block is injected after DOMContentLoaded)
    (function rvBoot(){
    if (!window.PDM || !PDM.renderRecentlyViewed) return;

    var tries = 0;
    var maxTries = 20;      // 20 * 150ms = 3s
    var delay = 150;

    function tick(){
        tries++;

        // If block exists, render and stop.
        // New multi-instance markup
        var anyBlock = document.querySelector('[data-pdm-recently-viewed] .pdm-recently-viewed-sections');

        // Legacy single-instance markup
        var rvRoot = document.getElementById('pdm-recently-viewed-root');
        var rvSections = document.getElementById('pdm-recently-viewed-sections');

        if (anyBlock || (rvRoot && rvSections)) {
          try { PDM.renderRecentlyViewed(); } catch(e) {}
          return;
        }

        // Retry a few times, then stop quietly.
        if (tries < maxTries) setTimeout(tick, delay);
    }

    tick();
    })();



})();